export function indexOfArrayObject(arr, obj, prop) {
  var index = -1;
  arr.some((val, ind) => {
      if(val[prop] === obj[prop]) {
          index = ind;
          return true;
      }
  });
  return index;
}

export function moveInArray(arr,newIndex,item){
  const ret = arr.slice(0);
  ret[newIndex] = item;
  return ret;
}

export function shuffleArray(array) {
  var currentIndex = array.length, temporaryValue, randomIndex;

  // While there remain elements to shuffle...
  while (0 !== currentIndex) {

    // Pick a remaining element...
    randomIndex = Math.floor(Math.random() * currentIndex);
    currentIndex -= 1;

    // And swap it with the current element.
    temporaryValue = array[currentIndex];
    array[currentIndex] = array[randomIndex];
    array[randomIndex] = temporaryValue;
  }

  return array;
}


// WEBPACK FOOTER //
// ./src/helpers/ArrayHelper.js